export default "__VITE_ASSET__UXO7JuxP__"